import axios from "axios";
import instance,{ BASE_URL } from "../../services/api";
import fileDownload from 'js-file-download';
import toast from 'react-hot-toast';


const AttendanceVeiwController = () => {

  const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};

  const getAttendance = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}attendance/`,
        {}
      );
      // console.log("Fetching attendance with params:", params);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_ATTENDANCE_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_ATTENDANCE_FAILURE",
        payload: { error: error }
      });
      toast.error(message); 
    }
  };

   const getEmployee = (date = null) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const url = date ? `${BASE_URL}employee/attendance/?date=${date}` : `${BASE_URL}employee/attendance/`;
      const response = await instance.get(url, {});
      // console.log("Fetching attendance with params:", params);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_EMPLOYEE_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_EMPLOYEE_FAILURE",
        payload: { error: error }
      });
      toast.error(message); 
    }
  };

  const addAttendance = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}attendance/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_ATTENDANCE_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
      return data;
    } catch (error) {

      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_ATTENDANCE_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
      throw error;
    }
  };

  const updateAttendence = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}attendance/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_ATTENDANCE_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
      return data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "UPDATE_ATTENDANCE_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
      throw error;
    }
  };

  const getMonthlyAttendance = (id, year, month, options = {}) => async (dispatch) => {
    const { silent = false, signal } = options;
    dispatch({ type: "LOADING", payload: true });
    try {
      const formattedMonth = `${year}-${String(month).padStart(2, "0")}`;
      const response = await instance.get(
        `${BASE_URL}monthly-attendance-summary/${id}/?month=${formattedMonth}`,
        signal ? { signal } : undefined
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_MONTHLY_ATTENDANCE_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      if (error.code === "ERR_CANCELED" || error.name === "CanceledError") {
        dispatch({ type: "LOADING", payload: false });
        return;
      }
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_MONTHLY_ATTENDANCE_FAILURE",
        payload: { error: error }
      });
      if (!silent) {
        toast.error(message, { id: "monthly-attendance-error" });
      }
    }
  };

  const getAttendanceStatus = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}attendance/attendance-status/`
      );
      // console.log("Fetching attendance with params:", params);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_LAST_ATTENDANCE_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_LAST_ATTENDANCE_FAILURE",
        payload: { error: error }
      });
      toast.error(message); 
    }
  };


  const genrateAttendanceReport = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });

    try {
      const response = await instance.post(
        `${BASE_URL}attendance/excel-report/`,
        reqData,
        {
          responseType: "blob", // important to get binary data
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let filename = "Attendance_Report.xlsx";
      if (reqData.start_date && reqData.end_date) {
        if (reqData.start_date === reqData.end_date) {
          filename = `Attendance_Report_${reqData.start_date}.xlsx`;
        } else {
          filename = `Attendance_Report_${reqData.start_date}_to_${reqData.end_date}.xlsx`;
        }
      } else if (reqData.month) {
        filename = `Attendance_Report_${reqData.month}.xlsx`;
      }

      // Download file
      fileDownload(response.data, filename);

      dispatch({ type: "GENRATE_ATTENDANCE_REPORT_SUCCESS" });
    } catch (error) {
      dispatch({
        type: "GENRATE_ATTENDANCE_REPORT_FAILURE",
        payload: { error },
      });
    } finally {
      dispatch({ type: "LOADING", payload: false });
    }
};

  const markManualAttendance = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}attendance/manual/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "MARK_MANUAL_ATTENDANCE_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
      toast.success(data.message || "Attendance marked manually");
      return data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "MARK_MANUAL_ATTENDANCE_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
      throw error;
    }
  };





  return {
    getAttendance,
    addAttendance,
    updateAttendence,
    getMonthlyAttendance,
    getAttendanceStatus,
    genrateAttendanceReport,
    getEmployee,
    markManualAttendance
  };
};

export default AttendanceVeiwController;
